import { render } from "./OrderCard.vue?vue&type=template&id=6705eebe&scoped=true&ts=true&lang=pug"
import script from "./OrderCard.vue?vue&type=script&lang=ts"
export * from "./OrderCard.vue?vue&type=script&lang=ts"

import "./OrderCard.vue?vue&type=style&index=0&id=6705eebe&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6705eebe"]])

export default __exports__